import * as ContextMenu from "ol-contextmenu";
import * as olProj from 'ol/proj';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Point from "ol/geom/Point";
import Stroke from "ol/style/Stroke";
import Icon from 'ol/style/Icon';
import Text from 'ol/style/Text';
import olMap from 'ol/Map';
import { Coordinate } from "ol/coordinate";

export class MapContextMenu {
   
    protected _contextMenu: ContextMenu;
    protected _vectorLayer: VectorLayer;

    protected _items: Array<any>;
    protected _titheItem: any;

    public constructor(
        private _map: olMap,
        private iconUrl: string = "/images/pin_drop.png",
        private _titheEnabled: boolean = false
    ) {
        this._vectorLayer = new VectorLayer({ source: new VectorSource() });
        this.init();
    }

    private init = (): void => {       
            let self = this;
           
            self._map.addLayer(self._vectorLayer);
            self._items = [
                '-', // this is a separator
                {
                    text: '<i class="fa fa-crosshairs" aria-hidden="true"></i>Center map here',
                    callback: function (obj) {
                        self.centerMap([obj.coordinate[0], obj.coordinate[1]]);
                    }
                },
                '-', // this is a separator
                {
                    text: '<i class="fa fa-solid fa-location-dot"></i>Google Maps',
                    callback: function (obj) {
                        self.openGoogleMaps([obj.coordinate[0], obj.coordinate[1]]);
                    }
                }
                //{
                //    text: '<i class="fa fa-map-marker" aria-hidden="true"></i>Add a marker}',
                //    callback: function (obj) {
                //        self.addMarker([obj.coordinate[0], obj.coordinate[1]]);
                //    }
                //}
            ];

            // Kept separate from self._items (which MapGridRef concats onto) so it can be
            // inserted conditionally per-click, in its own separated section below Google Maps.
            self._titheItem = {
                text: '<i class="fa fa-solid fa-scroll"></i>Tithe Maps Wales',
                callback: function (obj) {
                    self.openTitheMaps([obj.coordinate[0], obj.coordinate[1]]);
                }
            };

            self._contextMenu = new ContextMenu({
                width: 170,
                defaultItems: true,
                items: self._items
            });

            self._contextMenu.on('beforeopen', (evt) => {
                let element = self._map.getTargetElement();
                let { top, left } = element.getBoundingClientRect();

                //EDGE does not support document.elementsFromPoint
                if (document.elementsFromPoint && document.elementsFromPoint(evt.pixel[0] + left, evt.pixel[1] + top).some(e => e.id === 'popup')) {
                    self._contextMenu.disable();
                    return;
                }
            });

            self._contextMenu.getDefaultItems()[0].text = "Zoom in";
            self._contextMenu.getDefaultItems()[1].text = "Zoom out";

            self._contextMenu.on('open', function (evt) {
                self._contextMenu.clear();
                self._contextMenu.extend(self._contextMenu.getDefaultItems());
                let items = self._items.slice();
                if (self._titheEnabled) {
                    let coord3857 = self._map.getCoordinateFromPixel(evt.pixel);
                    if (coord3857 && self.isInWales(coord3857)) {
                        // Insert as its own separated section immediately below Google Maps
                        let gmIndex = items.findIndex(i => typeof i === "object" && i && i.text && i.text.indexOf("Google Maps") !== -1);
                        if (gmIndex !== -1) {
                            items.splice(gmIndex + 1, 0, '-', self._titheItem);
                        } else {
                            items.push('-', self._titheItem);
                        }
                    }
                }
                self._contextMenu.extend(items);
            });
           
            self._map.addControl(self._contextMenu);         
    }

    public addItems = (items: Array<any>): void => {
        this._contextMenu.extend(items);
        this._items = this._items.concat(items);
    }

    private centerMap = (coordinate: [number, number]): void => {
        this._map.getView().animate({ center: coordinate });
    }

    private openGoogleMaps = (coordinate: [number, number]): void => {
        let coord4326: Coordinate = olProj.transform(coordinate, "EPSG:3857", "EPSG:4326");
        let url = encodeURI(`https://www.google.com/maps/search/?api=1&query=${coord4326[1]},${coord4326[0]}`);
        window.open(url, '_blank');
    }

    private openTitheMaps = (coordinate: [number, number]): void => {
        let coord4326: Coordinate = olProj.transform(coordinate, "EPSG:3857", "EPSG:4326"); // [lng, lat]
        let url = encodeURI(`https://places.library.wales/browse/${coord4326[1].toFixed(5)}/${coord4326[0].toFixed(5)}/16.1/`);
        window.open(url, '_blank');
    }

    private isInWales = (coord3857: Coordinate): boolean => {
        let coord4326: Coordinate = olProj.transform(coord3857, "EPSG:3857", "EPSG:4326"); // [lng, lat]
        let lng = coord4326[0];
        let lat = coord4326[1];
        // Approximate Wales bounding box
        return lng >= -5.5 && lng <= -2.6 && lat >= 51.3 && lat <= 53.5;
    }

    public activate = ():void => {
        this._contextMenu.enable();
    }   

    public deactivate = (): void => {
        this._contextMenu.disable();
    }

    //public addMarker = (coordinate: [number, number]): void => {
    //    let template = 'Coordinate is ({x} | {y})',
    //        iconStyle = new Style({
    //            image: new Icon({ scale: .6, src: this.iconUrl }),
    //            text: new Text({
    //                offsetY: 25,
    //                text: this.getGridRef(coordinate),
    //                font: '15px Open Sans,sans-serif',
    //                fill: new Fill({ color: '#111' }),
    //                stroke: new Stroke({ color: '#eee', width: 2 })
    //            })
    //        }),
    //        feature = new Feature({
    //            type: 'removable',
    //            geometry: new Point(coordinate)
    //        });

    //    feature.setStyle(iconStyle);
    //    this._vectorLayer.getSource().addFeature(feature);
    //}

    //private getGridRef = (coordinate: [number, number]): string => {
    //    //transform from display projection to data projection
    //    let coords = olProj.transform(coordinate, this._map.options.displayProjection, this._map.options.dataProjection);
    //    return `${coords[0].toFixed(0)} ${coords[1].toFixed(0)}`;
    //}

    //private removeMarker = (marker: Feature): void => {
    //    this._vectorLayer.getSource().removeFeature(marker);
    //}
}